import { render, staticRenderFns } from "./SearchUserByDeliveryLabel.vue?vue&type=template&id=46f2cde8&"
import script from "./SearchUserByDeliveryLabel.vue?vue&type=script&lang=js&"
export * from "./SearchUserByDeliveryLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports